module.exports = __webpack_public_path__ + "static/media/Bettdecke_100x135_Kissen_80x60.4f434bb6.png";